<template>
  <div class="ws-search-form">
    <form @submit.prevent="submit">
      <b-field class="ws-field" :label="placeholder">
        <b-input class="ws-field__control ws-search-form__input"
                 type="search"
                 v-model="newKeyword"
                 expanded
                 @input="onInput" />
      </b-field>
    </form>
    <transition name="fade">
      <button v-if="newKeyword" class="button is-text ws-search-form__reset" type="button" @click.prevent="reset">
        <ws-icon
          class="ws-button__icon"
          name="close"
          color="#333"
          :fill="false"
          width="16"
          height="16"
        />
      </button>
    </transition>
  </div>
</template>

<script>
import { debounce } from 'debounce'

export default {
  name: 'WsSearchForm',
  props: {
    placeholder: {
      type: String
    },
    keyword: {
      type: String
    }
  },
  data () {
    return {
      newKeyword: this.keyword
    }
  },
  watch: {
    searchText: {
      handler (text) {
        if (text.length === 0) {
          this.reset()
        }
      }
    },
    keyword: {
      handler (keyword) {
        this.newKeyword = keyword
      }
    }
  },
  methods: {
    onInput: debounce(function () {
      this.submit()
    }, 1000),
    reset () {
      this.newKeyword = ''
      this.submit()
    },
    submit () {
      let keyword
      if (typeof this.newKeyword === 'string') {
        keyword = this.newKeyword.trim()
      }
      this.$emit('update:keyword', keyword)
    }
  }
}
</script>
